import {IConfig} from "@/config/types";

const config: IConfig = {
  version: "v1.0.0",
  project: "tywj",
  httpPrefix: "/api",
  timeOut: 60 * 60 * 1000,
  platformName: "田元万佳管理平台",
  company: "深圳市榆晟科技有限责任公司",
  uploadUrl: "/party/oss/ordinaryUpload",
  fragmentationUrl: "/party/oss/burstUpload",
  downloadUrl: "",
  videoDownloadUrl:'',
  rootPhones: [
    '13421398686'
  ]
}

export default config
